import { Link } from "react-router-dom";

const Features = () => {
  return (
    <div
      className="product-details__sidebar rounded-24 overflow-hidden"
      style={{
        border: "1px solid #f0f0f0",
        boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
      }}
    >
      <div className="p-16">
        <div className="flex-between bg-main-600 rounded-pill p-8">
          <div className="flex-align gap-8">
            <span className="w-44 h-44 bg-white rounded-circle flex-center text-2xl">
              <i className="ph ph-storefront" />
            </span>
            <span className="text-white fw-semibold">Fugus Fresh</span>
          </div>
          <Link
            to="/cart"
            className="btn btn-white rounded-pill text-uppercase text-sm fw-semibold"
          >
            View Cart
          </Link>
        </div>
      </div>
      <div className="p-20 d-flex align-items-start gap-16 border-bottom border-gray-100">
        <span
          className="w-40 h-40 rounded-circle flex-center text-lg flex-shrink-0"
          style={{ background: "#e3f2fd", color: "#1976d2" }}
        >
          <i className="ph-fill ph-truck" />
        </span>
        <div>
          <h6 className="text-sm mb-4 fw-semibold">Fast Delivery</h6>
          <p className="text-gray-600 text-xs mb-0">
            Lightning-fast shipping, guaranteed.
          </p>
        </div>
      </div>
      <div className="p-20 d-flex align-items-start gap-16 border-bottom border-gray-100">
        <span
          className="w-40 h-40 rounded-circle flex-center text-lg flex-shrink-0"
          style={{ background: "#e8f5e9", color: "#2e7d32" }}
        >
          <i className="ph-fill ph-check-circle" />
        </span>
        <div>
          <h6 className="text-sm mb-4 fw-semibold">Pickup available at Shop</h6>
          <p className="text-gray-600 text-xs mb-0">Usually ready in 24 hours</p>
        </div>
      </div>
      <div className="p-20 d-flex align-items-start gap-16">
        <span
          className="w-40 h-40 rounded-circle flex-center text-lg flex-shrink-0"
          style={{ background: "#fff3e0", color: "#f57c00" }}
        >
          <i className="ph-fill ph-credit-card" />
        </span>
        <div>
          <h6 className="text-sm mb-4 fw-semibold">Payment</h6>
          <p className="text-gray-600 text-xs mb-0">
            Google Pay, Card, UPI & Online payments accepted.
          </p>
        </div>
      </div>
    </div>
  );
};
export default Features;
